<template>
    <div class="driver-item" :class="itemClass" @click.stop="selected">
        <div class="avatar" :style="avatarStyle"/>
        <div class="content">
            <div class="name">
                #{{ driver.knight_id }} {{ driver.name }}
            </div>
            <div class="reason" v-if="driver.can_not_use_reason">
                {{ driver.can_not_use_reason }}
            </div>
            <div class="score" v-else>
                <img v-show="isSelected" src="@/assets/img/star-white.svg">
                <img v-show="!isSelected" src="@/assets/img/star.svg">
                {{ driver.score }}
            </div>
        </div>
        <div class="designate" v-if="isSelected">
            <div class="tag">
                已指定
                <img src="@/assets/img/selected.svg">
            </div>
        </div>
        <div class="favorite" @click.stop="toggleFavorite">
            <img v-show="!isFavorite && !isSelected" src="@/assets/img//heart.svg">
            <img v-show="isFavorite || isSelected" src="@/assets/img/heart-active.svg">
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { addDriver, deleteDriver } from '../../../apis'

    export default {
        name: "DriverItem",
        props: {
            driver: {
                require: true,
                type: Object,
            }
        },
        computed: {
            avatarStyle() {
                let url = require('@/assets/img/driver/default-avatar.svg');
                if (this.driver.avatar) {
                    url = this.driver.avatar.url;
                }
                return {
                    'background-image': `url("${url}")`
                }
            },
            itemClass() {
                return {
                    'selected': this.isSelected,
                    'disable': this.driver.can_not_use_reason != null,
                }
            },
            isSelected() {
                return this.cart.driver != null && this.cart.driver.id == this.driver.id;
            },
            isFavorite() {
                return this.driverIds.findIndex(id => id == this.driver.knight_id) >= 0;
            },
            ...mapGetters(['cart', 'driverIds'])
        },
        methods: {
            selected() {
                if (this.isSelected) {
                    return this.setCartData({
                        value: null,
                        key: 'driver'
                    });
                }

                if (this.driver.can_not_use_reason) {
                    return;
                }

                this.setCartData({
                    value: this.driver,
                    key: 'driver'
                })
            },
            toggleFavorite() {
                let ApiRequests = [
                    this.isFavorite ? deleteDriver(this.driver.knight_id) : addDriver(this.driver.knight_id),
                ];

                Promise.all(ApiRequests).then(() => {
                    this.getDriverIds();
                });
            },
            ...mapActions(['setCartData', 'getDriverIds']),
        }
    }
</script>

<style lang="scss" scoped>
    .driver-item {
        border-right: 5px;
        background-color: #fff;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        padding: 15px;
        display: flex;
        user-select: none;
        cursor: pointer;
        align-items: center;
        margin-bottom: 5px;

        .avatar {
            height: 40px;
            width: 40px;
            border-radius: 90px;
            background-position: 50% 50%;
            background-size: cover;
        }

        .content {
            margin-left: 15px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;

            .title {
                color: #000;
                font-size: 14px;
            }

            .score {
                margin-top: 5px;
                color: #339933;
                font-size: 12px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .favorite {
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 15px;
                height: 15px;
            }
        }

        .designate {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 15px;

            .tag {
                background-color: #339933;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 12px;
                padding: 2px 8px;
                font-size: 12px;
                color: #ffffff;
                line-height: 18px;

                img {
                    margin-left: 5px;
                    width: 16px;
                    height: 16px;;
                }
            }
        }

        &.selected {
            background-color: #B7DCB7;
            .content {
                color: #fff;
                .score {
                    color: #fff;
                }
            }
        }

        &.disable {
            cursor: default;

            .avatar {
                filter:opacity(.35) !important;
            }

            .content {
                color: #9b9b9b !important;
                .score {
                    color: #9b9b9b !important;
                }
            }
        }
    }
</style>